import { FormGroup } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { SiuTemplateDirective } from '../../../directives/siu-template.directive';

@Component({
  selector: 'siu-data-grid-form-filter',
  templateUrl: './data-grid-form-filter.component.html',
  styleUrls: [ './data-grid-form-filter.component.scss' ]
})
export class DataGridFormFilterComponent implements OnInit, AfterContentInit {

  @Input() formGroup: FormGroup;
  @Input() disableButtons: boolean = false;  
  @Output('on-submit') onSubmitEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-reset') onResetEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-new') onNewEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-export') onExportEvent: EventEmitter<any> = new EventEmitter();  
  @Output('on-via') onViaEvent: EventEmitter<any> = new EventEmitter();  
  @Output('on-ruta') onRutaEvent: EventEmitter<any> = new EventEmitter();  
  @Output('on-usuario') onUsuarioEvent: EventEmitter<any> = new EventEmitter();  
  @Output('on-alta') onAltaEvent: EventEmitter<any> = new EventEmitter();  


  
  @Input() noElevation: boolean = false;
  @Input() modalVariant: boolean = false;
  @Input() gridClass: string = 'grid';
  @Input() hideExport: boolean = false;
  @Input() hideNew: boolean = false;
  @Input() hideVia: boolean = true;
  @Input() hideRuta: boolean = true;
  @Input() hideUsuario: boolean = true;
  @Input() hideAlta: boolean = true;
  @Input() disableButtonExport: boolean = false;  

  @ContentChildren(SiuTemplateDirective) templates: QueryList<SiuTemplateDirective>;
  buttonsTemplate: any = null;
  buttonLeftTemplate: any = null;
  bottomSectionTemplate: any = null;

  
  labelVia: string="Vias";
  iconVia:any ="toll";

  labelRuta: string="Rutas";
  iconRuta:any ="alt_route";

  labelUsuario: string="Usuarios";
  iconUsuario:any ="supervisor_account";

  labelAlta: string="Alta";
  iconAlta:any ="explore";


  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    const tplButtons = this.templates.find(x => x.getType() == 'buttons');
    const tplButtonLeft = this.templates.find(x => x.getType() == 'buttons-left');
    const tplBottomSection = this.templates.find(x => x.getType() == 'bottom-section');
    if (tplButtons) {
      this.buttonsTemplate = tplButtons.template;
    }
    if (tplButtonLeft) {
      this.buttonLeftTemplate = tplButtonLeft.template;
    }
    if (tplBottomSection) {
      this.bottomSectionTemplate = tplBottomSection.template;
    }
  }

  HandleSubmit = () => {
    this.onSubmitEvent.emit();
  }

  HandleReset = () => {
    this.onResetEvent.emit();
  }

  HandleClickNew = () => {
    this.onNewEvent.emit();
  }

  HandleClickExport = () => {
    this.onExportEvent.emit();
  }
  
  HandleClickVia = () => {
    this.onViaEvent.emit();
  }

  HandleClickRuta = () => {
    this.onRutaEvent.emit();
  }
    
  HandleClickUsuario = () => {
    this.onUsuarioEvent.emit();
  }

  HandleClickAlta = () => {
    this.onAltaEvent.emit();
  }
}
